import React, { useEffect } from "react";

import { useDispatch, useSelector } from "react-redux";

import RegisterAuditory from "@auditory/component/RegisterAuditory";
import { AUDITORY_MODEL, DATA_MODEL } from "../models/model";
import SectionPersonalData from "../components/SectionPersonalData";
import { showModalAddBeneficiaries as showModalAddBeneficiariesAction } from "@/redux/actions/beneficiaries";
import { ModalAddBeneficiaries } from "@/components/organisms/ModalAddBeneficiaries";
import helpers from "@/utils/helpers";

const StepData = () => {
  const { showModalAddBeneficiaries } = useSelector(
    (state) => state.beneficiaries
  );

  const { userData } = useSelector((state) => state.vida);
  const isEmbedded = userData?.indPrevPageApp;

  const dispatch = useDispatch();

  useEffect(() => {
    return () => {
      dispatch(showModalAddBeneficiariesAction(false));
    };
  }, []);

  useEffect(() => {
    if (isEmbedded) {
      return helpers.sendMessageToApp(
        showModalAddBeneficiaries
          ? "EMBEDDED-APP-HIDE-TOPBAR"
          : "EMBEDDED-APP-SHOW-TOPBAR"
      );
    }
  }, [showModalAddBeneficiaries, isEmbedded]);

  return (
    <div className="rbr-rimac-grid">
      <RegisterAuditory authoring={AUDITORY_MODEL} />
      <SectionPersonalData {...DATA_MODEL} />
      {showModalAddBeneficiaries && (
        <ModalAddBeneficiaries
          isOpen={showModalAddBeneficiaries}
          nextStep="/comprar/seguro-vida-devolucion-garantizada/pago"
          stepFinish={3}
          product="Seguro Vida Devolución Garantizada"
        />
      )}
    </div>
  );
};

export default StepData;
